<mat-card-header style="display: block;">
  Select Locations
</mat-card-header>
<emm-cfa-data-table style="height:265px !important; display: block; overflow: scroll"
                [getData]="getData.bind(this)" [dataColumns]="dataColumns"
                [filterOptions]="filterOptions" [searchableOptions]="searchableOptions"
                [searchPlaceholder]="'Search Locations'" [primaryKey]="'tag'"
                [selectable]="true"
                [selectedItems]="selectedLocations"
                (selectionChange)="getSelectedLocations($event)">
</emm-cfa-data-table>
<div>
  <div  style="margin-top:30px;height:50px" class="flex-center-center">
    <button [attr.data-testid]="'cancel_button'" mat-raised-button matTooltip="Cancel"
            (click)="onNoClick()" style="margin-right:30px" type="button" class="button-color">Cancel </button>
    <button [attr.data-testid]="'save_button'" mat-raised-button matTooltip="Next"
            (click)="OnSubmit()" class="button-color">Save</button>
  </div>
</div>
